import React from 'react';
import { Quote, Star } from 'lucide-react';
import type { Testimonial } from '../types/sales';
function Stars() {
  return <div className="flex gap-1" aria-label="5 de 5 estrellas" data-id="element-257" data-mp="2gg681edqhg8a">
      {Array.from({
      length: 5
    }).map((_, index) => <Star key={index} className="h-3.5 w-3.5 fill-gold-400 text-gold-400" aria-hidden="true" data-id="element-258" data-mp="2kfosk91n7pal" data-mpi={index} />)}
    </div>;
}
interface TestimonialCardProps {
  testimonial: Testimonial;
}
export function TestimonialCard({
  testimonial
}: TestimonialCardProps) {
  return <figure className="flex h-full flex-col rounded-2xl border border-cream/10 bg-noir-800/65 p-5 text-left transition-colors duration-300 hover:border-gold-500/35 sm:p-7" data-id="element-259" data-mp="2z7z096kzaxey">
      <div className="flex items-center justify-between" data-id="element-260" data-mp="385980hyl84f4">
        <Stars data-id="element-261" data-mp="19r7qu1ctim2p" />
        <Quote className="h-5 w-5 text-gold-500/40" aria-hidden="true" data-id="element-262" data-mp="19rpv9l9mw6lp" />
      </div>
      <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-cream/75 sm:mt-5 sm:text-[15px]" data-id="element-263" data-mp="1drzxcmub2cva">
        “{testimonial.quote}”
      </blockquote>
      <figcaption className="mt-5 flex items-center gap-3 border-t border-cream/[0.08] pt-4 sm:mt-6 sm:pt-5" data-id="element-264" data-mp="hu5mokuc194l">
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-gold-500/12 font-display text-sm font-bold text-gold-400 ring-1 ring-gold-500/25" data-id="element-265" data-mp="d01drw1iar0v">
          {testimonial.name.charAt(0)}
        </span>
        <span className="text-xs text-cream/55" data-id="element-266" data-mp="10rf4jxk0eejq">
          <span className="block font-semibold text-cream/85" data-id="element-267" data-mp="10r6tmb7g5jb6">{testimonial.name}</span>
          {testimonial.age} años · {testimonial.city}
        </span>
      </figcaption>
    </figure>;
}